import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const VerifySuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <CheckCircle className="w-20 h-20 text-green-500" />
        </div>
        
        <h1 className="text-3xl font-bold text-foreground">
          Email Verified Successfully!
        </h1>
        
        <p className="text-muted-foreground">
          Thank you for verifying your email. We've received your message and will get back to you as soon as possible.
        </p>
        
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            You will be redirected to the homepage in 5 seconds...
          </p>
          
          <Button onClick={() => navigate('/')} className="w-full">
            Return to Homepage
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VerifySuccess;
